<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    </div>

    <div class="row clearfix">
      <!-- IZQUIERDA -->
      <div class="col-lg-4 col-md-12">
        <div class="card card-doctor-profile">
          <div class="profile-content">
            <img class="profile-img" [src]="resolvedPanelImage" alt="Foto del Medico" />
            <div class="profile-text">
              <div class="profile-name">{{ param ? 'EDITAR' : 'NUEVO' }} MEDICO</div>
              <div class="profile-subtext">Complete la informacion requerida</div>
            </div>
          </div>
        </div>
      </div>

      <!-- DERECHA -->
      <div class="col-lg-8 col-md-12">
        <div class="card">
          <form [formGroup]="userForm" class="register-form m-4" autocomplete="off" data-tour="doctor-form">
            <!-- DATOS DE ACCESO -->
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>lock</mat-icon>
                DATOS DE ACCESO
              </div>
              <div class="descripcion-seccion">CREDENCIALES DEL USUARIO PARA ACCEDER AL SISTEMA</div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>USUARIO</mat-label>
                    <input formControlName="usr" matInput required data-tour="doctor-usr"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('usr')?.touched && userForm.get('usr')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">USUARIO OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('usr')?.touched && userForm.get('usr')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO LETRAS, NUMEROS, ESPACIOS, PUNTOS, GUIONES Y GUION BAJO.</small>
                  </div>
                </div>

                <div class="col-md-8 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                    <mat-label>CORREO ELECTRONICO</mat-label>
                    <input formControlName="email" matInput required data-tour="doctor-email"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('email')?.touched && userForm.get('email')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CORREO ELECTRONICO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('email')?.touched && userForm.get('email')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">INGRESE UNA DIRECCION DE CORREO VALIDA.</small>
                  </div>
                </div>
              </div>

              <!-- ✅ SOLO MX + ADMIN -->
              <div class="row" *ngIf="showParticularToggle">
                <div class="col-md-12 mb-2">
                  <div class="particular-toggle-box">
                    <mat-checkbox
                      [(ngModel)]="isParticularSelected"
                      [ngModelOptions]="{ standalone: true }">
                      REGISTRAR COMO PARTICULAR
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>

            <!-- DATOS PERSONALES -->
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>person</mat-icon>
                DATOS PERSONALES
              </div>
              <div class="descripcion-seccion">INFORMACION GENERAL DEL MEDICO</div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>NOMBRE(S)</mat-label>
                    <input formControlName="nombres" matInput required data-tour="doctor-nombres"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('nombres')?.touched && userForm.get('nombres')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">NOMBRES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('nombres')?.touched && userForm.get('nombres')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>PRIMER APELLIDO</mat-label>
                    <input formControlName="primerApellido" matInput required data-tour="doctor-apellido-paterno"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('primerApellido')?.touched && userForm.get('primerApellido')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">PRIMER APELLIDO OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('primerApellido')?.touched && userForm.get('primerApellido')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SEGUNDO APELLIDO</mat-label>
                    <input formControlName="segundoApellido" matInput required data-tour="doctor-apellido-materno"/>
                  </mat-form-field>
                  <div *ngIf="userForm.get('segundoApellido')?.touched && userForm.get('segundoApellido')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">SEGUNDO APELLIDO OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('segundoApellido')?.touched && userForm.get('segundoApellido')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO LETRAS Y ESPACIOS.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>TELEFONO MOVIL</mat-label>
                    <ngx-mat-intl-tel-input
                      formControlName="movil"
                      [preferredCountries]="preferredCountries"
                      [enablePlaceholder]="true" data-tour="doctor-movil">
                    </ngx-mat-intl-tel-input>
                  </mat-form-field>
                  <div *ngIf="userForm.get('movil')?.touched && userForm.get('movil')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL NUMERO DE CELULAR ES OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>{{ (userForm.get('settlementSearch')?.value ? 'COLONIA' : 'CODIGO POSTAL') | regionWord }}</mat-label>
                    <input
                      matInput
                      [matAutocomplete]="auto"
                      formControlName="settlementSearch"
                      (blur)="onSettlementBlur()" data-tour="doctor-cp-colonia"/>
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      (optionSelected)="setSelectedSettlement($event.option.value)"
                      [displayWith]="displayFn">
                      <mat-option *ngFor="let option of settlements" [value]="option">
                        {{ option.asentamiento }}, {{ option.estado }} - CP: {{ option.codigoPostal }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL CODIGO POSTAL ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('settlementSearch')?.touched && userForm.get('settlementSearch')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">INGRESA UN CODIGO POSTAL VALIDO.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>DIRECCION</mat-label>
                    <textarea formControlName="domicilio" matInput required data-tour="doctor-domicilio"></textarea>
                  </mat-form-field>
                  <div *ngIf="userForm.get('domicilio')?.touched && userForm.get('domicilio')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL DOMICILIO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="userForm.get('domicilio')?.touched && userForm.get('domicilio')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS, NUMEROS Y CARACTERES . , _ # / - ( ).</small>
                  </div>
                </div>
              </div>
            </div>

            <!-- EMPRESA (visible segun rol) -->
            <div class="seccion-formulario" *ngIf="showEmpresaSection">
              <div class="titulo-seccion">
                <mat-icon>business</mat-icon>
                EMPRESA
              </div>
              <div class="descripcion-seccion">GRUPO Y SUCURSAL DE TRABAJO</div>

              <div class="row">
                <div class="col-md-6 mb-2" *ngIf="showGempSelect">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>GRUPO EMPRESARIAL</mat-label>
                    <mat-select formControlName="idGEMP" (selectionChange)="getBranchesByGemp()" required data-tour="doctor-gemp">
                      <mat-option *ngFor="let row of businessGroups" [value]="row.idGEMP">
                        {{ row.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="userForm.get('idGEMP')?.touched && userForm.get('idGEMP')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">GRUPO EMPRESARIAL OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2" *ngIf="showSucursalSelect">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>SUCURSAL</mat-label>
                    <mat-select formControlName="idSucursal" required data-tour="doctor-sucursal">
                      <mat-option *ngFor="let row of branches" [value]="row.idSucursal">
                        {{ row.nombre }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="userForm.get('idSucursal')?.touched && userForm.get('idSucursal')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">SUCURSAL OBLIGATORIA.</small>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <!-- DATOS MEDICOS -->
          <form [formGroup]="doctorForm" class="register-form m-4" autocomplete="off" data-tour="doctor-med-form">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>medical_services</mat-icon>
                DATOS MEDICOS
              </div>
              <div class="descripcion-seccion">CEDULAS, COLEGIADO, UNIVERSIDAD, ESPECIALIDAD</div>

              <div class="row">
                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>CEDULA GENERAL</mat-label>
                    <input formControlName="cedulaGeneral" matInput required data-tour="doctor-cedula-general"/>
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('cedulaGeneral')?.touched && doctorForm.get('cedulaGeneral')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">LA CEDULA GENERAL ES OBLIGATORIA.</small>
                  </div>
                  <div *ngIf="doctorForm.get('cedulaGeneral')?.touched && doctorForm.get('cedulaGeneral')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">LA CEDULA GENERAL DEBE TENER 9 DIGITOS.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>COLEGIADO</mat-label>
                    <mat-select formControlName="colegiado" required data-tour="doctor-colegiado">
                      <mat-option *ngFor="let opt of colegiadoOptions" [value]="opt.id">
                        {{ opt.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('colegiado')?.touched && doctorForm.get('colegiado')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL COLEGIADO ES OBLIGATORIO.</small>
                  </div>
                </div>

                <div class="col-md-4 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>UNIVERSIDAD</mat-label>
                    <input formControlName="universidad" matInput required data-tour="doctor-universidad"/>
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('universidad')?.touched && doctorForm.get('universidad')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">LA UNIVERSIDAD ES OBLIGATORIA.</small>
                  </div>
                  <div *ngIf="doctorForm.get('universidad')?.touched && doctorForm.get('universidad')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>ESPECIALIDAD</mat-label>
                    <input formControlName="especialidad" matInput data-tour="doctor-especialidad"/>
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('especialidad')?.touched && doctorForm.get('especialidad')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS Y ESPACIOS.</small>
                  </div>
                </div>

                <div class="col-md-6 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>CEDULA ESPECIALIDAD</mat-label>
                    <input formControlName="cedulaEspecialidad" matInput data-tour="doctor-cedula-especialidad"/>
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('cedulaEspecialidad')?.touched && doctorForm.get('cedulaEspecialidad')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">LA CEDULA ESPECIALIDAD DEBE TENER 6 A 8 DIGITOS.</small>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 mb-2">
                  <mat-form-field appearance="outline" class="example-full-width">
                    <mat-label>HORARIO</mat-label>
                    <input formControlName="horario" matInput required data-tour="doctor-horario"/>
                  </mat-form-field>
                  <div *ngIf="doctorForm.get('horario')?.touched && doctorForm.get('horario')!.hasError('required')" class="custom-error-below">
                    <small class="text-danger">EL HORARIO ES OBLIGATORIO.</small>
                  </div>
                  <div *ngIf="doctorForm.get('horario')?.touched && doctorForm.get('horario')!.hasError('pattern')" class="custom-error-below">
                    <small class="text-danger">SOLO SE PERMITEN LETRAS, NUMEROS, ESPACIOS, PUNTOS, GUIONES Y GUION BAJO.</small>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <!-- CONFIGURACION -->
          <form [formGroup]="archiveForm" class="register-form m-4" autocomplete="off">
            <div class="seccion-formulario">
              <div class="titulo-seccion">
                <mat-icon>settings</mat-icon>
                CONFIGURACION
              </div>
              <div class="descripcion-seccion">ARCHIVOS DE USUARIO</div>

              <label class="fw-semibold">IMAGEN DE PERFIL (JPG, PNG, JPEG)</label>
              <app-file-upload
                formControlName="imagen"
                [acceptedTypes]="'image/*'"
                [externalSrc]="param ? (userImagen ?? null) : null"
                [circle]="true"
                [targetKB]="10"
                [initialMaxSize]="320" data-tour="doctor-imagen">
              </app-file-upload>

              <label class="fw-semibold">FIRMA DIGITAL (JPG, PNG, JPEG)</label>
              <app-file-upload
                formControlName="firma"
                [acceptedTypes]="'image/*'"
                [externalSrc]="param ? (resolvedSignatureImage ?? null) : null"
                [circle]="true"
                [targetKB]="10"
                [initialMaxSize]="320" data-tour="doctor-firma">
              </app-file-upload>

            </div>

            <button
              data-tour="doctor-btn-guardar"
              (click)="confirmAdd()"
              [disabled]="(!userForm.valid || !doctorForm.valid) && !param"
              [ngClass]="{
                'button-custom': true,
                'disabled': (!userForm.valid || !doctorForm.valid) && !param
              }"
              color="primary"
              mat-button>
              {{
                (!userForm.valid || !doctorForm.valid) && !param
                  ? 'FORMULARIO INCOMPLETO'
                  : (param ? 'EDITAR USUARIO' : 'CREAR USUARIO')
              }}
            </button>

          </form>
        </div>
      </div>
    </div>
  </div>
</section>
